<template>
  <v-layout justify-space-between align-center class="px-6 pt-4" style="min-height: var(--header-height); max-height: var(--header-height)">
    <v-flex shrink flex-center>
<!--      <v-img-->
<!--          class="mr-4"-->
<!--          :src="require('../assets/img/jitta-full-logo.png')"-->
<!--          max-width="132"-->
<!--      ></v-img>-->
      <div v-if="isLoading" class="loader-outer">
        <div class="loader-inner"></div>
      </div>
    </v-flex>
    <v-flex shrink flex-center gap-12>
      <div class="breadcrumbs">
        <div
            v-for="(r, i) in returnBreadcrumb"
            :key="i"
        >
          <span v-if="i !== 0" class="theme-color-eight mr-2">/</span>
          <a
              v-if="(i + 1) !== returnBreadcrumb.length"
              :href="r.path"
          >
            {{ r.meta.bcName ? r.meta.bcName : r.name }}
          </a>
          <span v-else class="theme-color-one">
            {{ customBcName ? customBcName : (r.meta.bcName ? r.meta.bcName : r.name) }}
          </span>
        </div>
      </div>
      <div class="role-tag txt-mini" @click="roleChangeTEST">
        {{ roles[userRole] ? roles[userRole] : userRole }}
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex'
import { clearCookie__c } from "../plugins/cookies"
import { eventBus } from "../plugins/global-funcs"

export default {
  name: "Header",
  data () {
    return {
      roles: {
        RSP: 'RSP: Regional Science Park',
        USP: 'USP: University Science Park',
      },
      customBcName: ''
    }
  },
  created () {
    eventBus.$on('customBcName', (text) => {
      this.customBcName = text
    })
  },
  computed: {
    ...mapState({
      confirmModalTitle: state => state.General.confirmModal.title,
      isLoading: state => state.General.isLoading,
      userRole: state => state.Auth.User?.user_type
    }),
    returnBreadcrumb () {
      let route = this.$route
      let routes = this.$router.getRoutes()
      let bcs = [route]
      if (route && route.meta.parentName) {
        while (route.meta.parentName) {
          let p = routes.find(x => x.name === route.meta.parentName)
          bcs.unshift(p)
          route = p
        }
        return bcs
      }
      return bcs
    }
  },
  mounted () {
    eventBus.$on('spin-gear', bool => {
      if (bool) {
        this.$refs.settingBtn.$el.classList.add('spin-setting')
      } else {
        this.$refs.settingBtn.$el.classList.remove('spin-setting')
      }
    })
  },
  methods: {
    toSettingPage () {
      this.$router.push({ name: "Setting" })
    },
    onSignout () {
      this.$store.commit('General/setModal', {
        title: 'Sign out',
        text: 'Are you sure to sign out?',
        buttonText: 'Sign out',
        action: () => {
          clearCookie__c('session_login')
          this.$router.push({ name: "Login" })
        }
      })
    },
    // TODO: Remove this function
    roleChangeTEST () {
      this.$store.commit('Auth/setRole')
    }
  }
}
</script>

<style scoped>
.loader-inner {
  border-radius: 100%;
  background: var(--main-bg-color);
  min-height: 16px;
  max-height: 16px;
  min-width: 16px;
  max-width: 16px;
}

.loader-outer {
  width: 20px;
  height: 20px;
  border-radius: 100%;
  background: linear-gradient(var(--main-bg-color) 18%, var(--theme-color-one) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  animation: spin .75s linear infinite;
}

.spin-setting {
  animation: spin 1.25s linear infinite;
}

.role-tag {
  background: #464647;
  border-radius: 20px;
  padding: 4px 20px;
  color: #fff;
}

.breadcrumbs {
  display: flex;
  gap: 12px;
  font-size: 12px;
  font-family: var(--font-bold-type);
}
</style>